import { createSlice } from '@reduxjs/toolkit';
import { initStateGetCountryList, reducerGetCountryList } from '../actions/app/getCountryList';
import { initStateGetFilterGameList, reducerGetFilterGameList } from '../actions/app/getFilterGameList';
import { initStateGetTypePaymentList, reducerGetTypePaymentList } from '../actions/app/getTypePayment';

export const initialState = {
  modalTask: false,
  modalWork: false,
  workData: null,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setModalTask(state, action) {
      state.modalTask = action.payload;
    },
    setModalWork(state, action) {
      state.modalWork = action.payload;
    },
    setWorkData(state, action) {
      state.workData = action.payload;
    },
  },
  extraReducers: {},
});
export const { setWorkData, setModalTask, setModalWork } = appSlice.actions;
export const appReducer = appSlice.reducer;
